// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"ShoppingCartRequiresCompanyAccess_paginationPageDropdownWrap__ZPYL0","pageContainer":"ShoppingCartRequiresCompanyAccess_pageContainer__AtQNv"};